import React from 'react'
import {
    Box,
    DialogContent,
    DialogActions,
    Button,
} from '@mui/material';
import BootstrapDialog, { BootstrapDialogTitle } from '../../../components/common/dialog/BootstrapDialog';
import DetailTemplate from '../../../components/common/template/DetailTemplate';
import NoticeView from '../../../components/dashboard/notice/NoticeView';
import NoticeFileListContainer from './NoticeFileListContainer';


const NoticeModalContainer = ({ notice, open, handleClose }) => {
    return (
        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="dialog-title"
            open={open}
            fullWidth={true}
            maxWidth="md"
        >
            <BootstrapDialogTitle id="dialog-title" onClose={handleClose}>
                {notice?.wrTitle}
            </BootstrapDialogTitle>
            <DialogContent
                dividers
                sx={{
                    height: 400,
                    overflowY: 'auto',
                }}
            >
                <DetailTemplate title="공지사항">
                    <NoticeView notice={notice} />
                </DetailTemplate>
                <DetailTemplate title="첨부파일">
                    <NoticeFileListContainer notice={notice} />
                </DetailTemplate>
            </DialogContent>
            <DialogActions>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        m: 1,
                    }}
                >
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={handleClose}
                    >
                        닫기
                    </Button>
                </Box>
            </DialogActions>
        </BootstrapDialog>
    )
}

export default NoticeModalContainer